import type { SelectOptions } from "components/SelectUI/Select.model";
import { useEffect, useMemo } from "react";

import { filterEducations } from "_helpers/optionsParser";

import { useLogin } from "./useLogin";
import { useProduct } from "./useProduct";

interface UserFormInterface {
  getEducations: (
    schoolId: string,
    educations?: string[],
    selectedEducation?: string,
  ) => SelectOptions[];
  getProductTitle: (productId: number) => string;
  schools: SelectOptions[];
}

export const useUserForm = (): UserFormInterface => {
  const { getSchoolList, schoolList = [] } = useLogin();
  const { productsList, fetchProducts } = useProduct();

  useEffect(() => {
    getSchoolList();
  }, [getSchoolList]);

  useEffect(() => {
    if (!productsList) {
      fetchProducts();
    }
  }, [productsList, fetchProducts]);

  const schools = useMemo(
    () =>
      schoolList.map((schoolItem) => ({
        value: schoolItem.id,
        label: schoolItem.title,
      })),
    [schoolList],
  );

  const getEducations = (schoolId: string, educations: string[] = [], selectedEducation = "") => {
    const schoolEducations = schoolList.find((school) => school.id === schoolId)?.educations || [];
    return filterEducations(schoolEducations, educations, selectedEducation);
  };

  const getProductTitle = (productId: number) =>
    productsList?.find((product) => product.id === productId)?.title || "";

  return {
    getEducations,
    getProductTitle,
    schools,
  };
};
